const stsFont = {
  "header-font": ["DM Serif Display", "sans-serif"],
  ciutadella: ["Ciutadella Rounded", "sans-serif"],
  "sub-section-header-font": [
    "proxima-nova",
    "Helvetica",
    "Arial",
    "sans-serif",
  ],
  "proxima-nova": ["proxima-nova", "Helvetica", "Arial", "sans-serif"],
  "body-font": ["proxima-nova", "Helvetica", "Arial", "sans-serif"],
  opensans: ["Open Sans", "sans-serif"],
  "semibold-font": ["proxima-nova", "sans-serif"],
  "source-sans-pro-regular": ["source-sans-pro-regular", "sans-serif"],
  helvetica: ["Helvetica Neue", "Helvetica", "Arial", "sans-serif"],
  faktum: ["faktum", "proxima-nova", "sans-serif"],
};

export default stsFont;
